import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Mobile16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path d='M10 4.75H6V3.25H10V4.75Z' fill='currentColor' />
    <path
      d='M9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.75 1.4375C2.75 0.761886 3.30732 0.25 3.95 0.25H12.05C12.6927 0.25 13.25 0.761886 13.25 1.4375V14.5625C13.25 15.2381 12.6927 15.75 12.05 15.75H3.95C3.30732 15.75 2.75 15.2381 2.75 14.5625V1.4375ZM4.25 1.75V14.25H11.75V1.75H4.25Z'
      fill='currentColor'
    />
  </Svg>
);

Mobile16.displayName = 'Mobile16';
export default Mobile16;
